module.exports = __webpack_public_path__ + "static/media/marker_pluscircle_2.540bd873.png";